<template>
  <div class="product-stat">
    <div
      class="product-stat__header mb-m"
    >
      <p
        class="product-stat__title"
        :class="labelClass"
        v-text="label"
      />
    </div>

    <div class="product-stat__content">
      <div class="product-stat__value">
        <span
          class="product-stat__value-number"
          :class="numberClass"
          v-text="value"
        />

        <span
          class="product-stat__value-unit"
          :class="unitClass"
          v-text="unit"
        />
      </div>

      <p
        class="product-stat__description"
        :class="descClass"
        v-text="desc"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product stat (product-stat)
 * -----------------------------------------------------------------------------
 * Global product spec template
 *
 */
export default {
  name: 'ProductStat',

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    unit: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    numberClass: {
      type: String,
      default: 'text-heading-l',
    },
    labelClass: {
      type: String,
      default: 'text-body-xl-regular',
    },
    unitClass: {
      type: String,
      default: 'text-body-xl-bold',
    },
    descClass: {
      type: String,
      default: 'text-body-l-regular',
    },
  },
}
</script>
